// utils/courseSchema.js
// Map booking session records -> schema.org CourseInstance objects.

// Standard bundle product ID -> its diploma-tier product ID.
// Mirrors the pid/pid_diploma pairs used by the bundle shortcode. Kept here
// because products.json is build-generated and can't carry the relationship.
export const DIPLOMA_TIER = {
  10193: 10194,   // Teaching Young Learners
  10196: 10195,   // Teaching Business English
  10197: 10198,   // Teaching English Online
  30000: 30001    // Ultimate
}

function isVirtual(rec) {
  return rec && rec.venue && rec.venue.town === 'Online'
}

export function sessionInstances(list, opts) {
  opts = opts || {}
  const out = []
  if (!list || !list.length) return out
  const counts = {}
  const cap = opts.perVenueCap || 0
  const workload = opts.classroomWorkload || ''

  for (let i = 0; i < list.length; i++) {
    const rec = list[i]
    if (!rec || rec.code === 'flexible' || !rec.startDate) continue          // no fixed date
    if (rec.maxAttendees != null && rec.numAttendees != null &&
        (rec.maxAttendees - rec.numAttendees) <= 0) continue                 // sold out
    const key = (rec.venue && rec.venue.town) || 'x'
    if (cap) {
      counts[key] = (counts[key] || 0) + 1
      if (counts[key] > cap) continue                                        // keep the page lean
    }

    const inst = { '@type': 'CourseInstance', startDate: rec.startDate }
    if (rec.endDate) inst.endDate = rec.endDate
    if (workload) inst.courseWorkload = workload

    if (isVirtual(rec)) {
      inst.courseMode = 'online'
      inst.location = { '@type': 'VirtualLocation', url: opts.url }
    } else {
      const venue = rec.venue || {}
      inst.courseMode = 'onsite'
      inst.location = {
        '@type': 'Place',
        name: venue.name || '',
        address: {
          '@type': 'PostalAddress',
          streetAddress: venue.line1 || undefined,
          addressLocality: venue.city || venue.town || '',
          postalCode: venue.postcode || undefined,
          addressCountry: venue.country || 'GB'
        }
      }
    }
    out.push(inst)
  }
  return out
}